export default __webpack_public_path__ + "static/media/nextjs.dc303387.svg";